<script setup lang="ts">
import {onBeforeUnmount, ref, watch} from 'vue'
import {useLocalMessageStore} from '@toolify/client/src/stores/LocalMessageStore/useLocalMessageStore'
import {
  MessageAnnouncementChannelType,
} from '@toolify/client/src/modules/notifications/enum/MessageAnnouncementChannelType'

// The two sr-only mirrors of the local messages. Mounted by AppContent outside the overlay's
// loading gate, so a region already exists when the first card (pushed during the splash) is read out.
const localMessageStore = useLocalMessageStore()

const politeText = ref('')
const assertiveText = ref('')
const frameIds = new Set<number>()

// the region is emptied first and filled one frame later, so the same text is read again
watch(() => localMessageStore.lastAnnouncement, announcement => {
  if(!announcement) {
    return
  }
  const region = announcement.channel === MessageAnnouncementChannelType.Assertive ? assertiveText : politeText
  region.value = ''
  const frameId = requestAnimationFrame(() => {
    frameIds.delete(frameId)
    region.value = announcement.text
  })
  frameIds.add(frameId)
}, {flush: 'sync'})

onBeforeUnmount(() => {
  frameIds.forEach(frameId => cancelAnimationFrame(frameId))
  frameIds.clear()
})
</script>

<template>
  <div
    class="tw-sr-only"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    {{politeText}}
  </div>
  <div
    class="tw-sr-only"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    {{assertiveText}}
  </div>
</template>
